import { render } from "./WorkflowFromDocPage.vue?vue&type=template&id=dceed71c&scoped=true"
import script from "./WorkflowFromDocPage.vue?vue&type=script&lang=js"
export * from "./WorkflowFromDocPage.vue?vue&type=script&lang=js"

import "./WorkflowFromDocPage.vue?vue&type=style&index=0&id=dceed71c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dceed71c"]])

export default __exports__